import type { FC } from 'react';
import styles from '../styles/completion.module.scss';
import ActionButton from '../components/action-button';
import TitleBox from '../components/title-box';
import GreyBorderedBox from '../components/grey-bordered-box';
import BulletList from '../components/bullet-list';

type CompletionProps = {
    onClose: () => void;
} & (
    | { type: 'new'; confirmationId: string }
    | { type: 'edit'; confirmationId: string }
    | { type: 'cancel' }
);

const TITLES: Record<CompletionProps['type'], string> = {
    new: '修理の予約を承りました',
    edit: '予約の変更を承りました',
    cancel: '予約のキャンセルを承りました',
};

const TEXTS: Record<CompletionProps['type'], string> = {
    new: 'ご予約内容は、ご登録いただいた電話番号またはメールアドレスにお送りしています。\n当日はお気をつけてお越しください。',
    edit: 'ご予約内容は、ご登録いただいた電話番号またはメールアドレスにお送りしています。\n当日はお気をつけてお越しください。',
    cancel: 'ご登録いただいた電話番号またはメールアドレスに、キャンセル内容をSMSまたはEメールでお送りしています。\nまた、お困りごとなどありましたらお気軽にご相談・ご予約ください。',
};

const Completion: FC<CompletionProps> = (props) => {
    return (
        <div className={styles.completion}>
            <div className={styles.completeTitle}>{TITLES[props.type]}</div>
            <div className={styles.completeText}>
                {TEXTS[props.type].split('\n').map((line, i) => (
                    <span key={i}>
                        {i > 0 && <br />}
                        {line}
                    </span>
                ))}
            </div>
            {props.type !== 'cancel' && (
                <>
                    <TitleBox title={`予約番号：${props.confirmationId}`} />
                    <GreyBorderedBox className={styles.bookingNotice}>
                        <div className={styles.title}>ご来店時にお持ちいただきたいもの</div>
                        <BulletList>
                            <li>修理依頼品</li>
                            <li>ご本人さま確認書類（原本）</li>
                        </BulletList>
                        <a href="#">ご本人さま確認書類について</a>
                        <div>
                            ご来店される方がご契約者ご本人でない場合、上記に加え「 代理人委任状
                            」をお持ちください。
                            委任状（日本語版・外国語版）は以下よりダウンロードいただけます。
                        </div>
                        <a href="#">委任状</a>
                    </GreyBorderedBox>
                </>
            )}
            <ActionButton className={styles.closeButton} title="閉じる" onClick={props.onClose} />
        </div>
    );
};

export default Completion;
